module.exports = "<my-area-create-form my-area=\"$$area.data.myArea\"\n  enable-title=\"true\"\n  enable-back=\"true\">\n</my-area-create-form>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/consult/area/templates/new.html
// module id = 1484
// module chunks = 0